import React from "react";
import "./gradientText.scss";

const GradientText = ({ children, className, variant }) => {
	return (
		<span className={`gradientText ${className} ${variant} `}>{children}</span>
	);
};

export default GradientText;
